var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-select',{class:{
		'menu-active':_vm.isOPen
	},style:({
		width:_vm.styleWidth
	}),attrs:{"placeholder":""},on:{"change":_vm.onChange,"focus":_vm.focus,"blur":_vm.blur},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.options),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.text,"value":item.value}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }